import {
  BrandNotConnectedView,
  PaymentOptionsUnavailableView,
} from './components/EmptyPayView/EmptyPayViews'
import { Invoice } from './components/Invoice/Invoice'
import { checkLiteRetailerConditions } from './utils'

type LiteRetailerPayViewProps = {
  hasInvoiceBeenSent: boolean
  paymentProvider: {
    paymentProvider: string
    retailersCanSeeInvoices: boolean
  } | null
  brandName?: string
  joorPayUseReach?: boolean
}

const LiteRetailerPayView = ({
  hasInvoiceBeenSent,
  paymentProvider,
  brandName,
  joorPayUseReach,
}: LiteRetailerPayViewProps) => {
  const shouldRender = checkLiteRetailerConditions({
    paymentProvider: paymentProvider ? paymentProvider?.paymentProvider : null,
    joorPayUseReach: !!joorPayUseReach,
    showInvoicesAutomatically: !!paymentProvider?.retailersCanSeeInvoices,
    paymentLinkSent: !!hasInvoiceBeenSent,
  })

  if (shouldRender === 'invoice') {
    return <Invoice />
  }

  if (shouldRender === 'disabled-payment-options') {
    return <PaymentOptionsUnavailableView brandName={brandName} />
  }

  if (shouldRender === 'disabled-brand-connected') {
    return <BrandNotConnectedView brandName={brandName} />
  }

  return null
}

export default LiteRetailerPayView
